import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';

import { twMerge } from 'tailwind-merge';

import Icon from 'components/icon/icon';

import Collapsible from './Collapsible';

interface headerProps {
  title?: string;
  isJobPersonal?: boolean;
  isJobaChoice?: boolean;
  isDerivedJob?: boolean;
  isAvailable?: boolean;
}

interface PanelProps {
  Header: React.FC<headerProps>;
  headerClassName?: string;
  children?: ReactNode[] | ReactNode;
  headerTitle?: string;
  isJobPersonal?: boolean;
  isJobaChoice?: boolean;
  closePanel?: boolean;
  isOpenInitially?: boolean;
  isDerivedJob?: boolean;
  isAvailable?: boolean;
  setClosePanel?: (status: boolean) => void;
}

const Panel: React.FC<PanelProps> = (props) => {
  const {
    Header,
    headerClassName,
    headerTitle,
    isJobaChoice,
    isJobPersonal,
    closePanel,
    setClosePanel,
    isOpenInitially,
    isDerivedJob,
    isAvailable,
  } = props;

  const [isOpen, setIsOpen] = useState(isOpenInitially || false);
  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (closePanel) {
      setIsOpen(false);
      setClosePanel?.(false);
    }
  }, [closePanel, setClosePanel]);

  const headerClassNames = twMerge(
    'container h-fit w-full flex justify-between items-center cursor-pointer p-0',
    'peer z-0',
    headerClassName,
    isAvailable === false &&
      'bg-gray200 outline outline-[1px] outline-gray-300 shadow-none hover:bg-gray300',
    isOpen && 'rounded-t-md rounded-b-none',
    !isOpen && 'rounded-md',
  );
  return (
    <div className="container flex flex-col rounded-md items-center justify-start w-full px-0 border border-slate300">
      <button type="button" className={headerClassNames} onClick={handleOpen}>
        <Header
          title={headerTitle}
          isJobaChoice={isJobaChoice}
          isJobPersonal={isJobPersonal}
          isDerivedJob={isDerivedJob}
          isAvailable={isAvailable}
        />
        <Icon
          icon={!isOpen ? 'arrow_down' : 'arrow_up'}
          className=" text-body-large mr-1 md:mr-2"
          size={32}
        />
      </button>
      <Collapsible isOpen={isOpen}>{props.children}</Collapsible>
    </div>
  );
};
export default Panel;
